import { useTranslateContext } from "fennec-ui";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router";
import { access } from "../../../../../common/Tool";
import MenuLevelThree from "../../../../components/MenuLevelThree";
import Status from "./Status";
import Notifications from "./Notifications";
import { notifyForHeader, statusForHeader } from "../../../../components/MenuLevelTwo";

const menu = (status, notify) => {
    const x = [
        {
            uuid: "notifications",
            default: true,
            name: "Оповещения",
            component: (props) => (<Notifications {...props} />),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ],
            badge: (element) => {
                var noty = notifyForHeader(notify);
                return {
                    count: noty.length
                }
            }
        },
        {
            uuid: "status",
            name: "Статусы",
            component: (props) => (<Status {...props} />),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ],
            badge: (element) => {
                var stat = statusForHeader(status);
                return {
                    count: stat.length
                }
            }
        },
    ]
    return x
};

export default function Main(props) {
    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status);
    const notify = useSelector(state => state.home.notify);
    const t = useTranslateContext();

    return (
        <div className='page' style={{ height: "100%", padding: "0px 5px" }}>
            <MenuLevelThree menu={menu(status, notify)} />
            <Routes>
                {menu(status, notify).map((e, idx) => {
                    if (e.default && access(e, role_by_id)) {
                        return <Route key={"index-" + e.uuid} index element={<Navigate replace to={e.uuid} />} />
                    }
                })}
                {menu(status, notify).map((e, idx) => {
                    if (e.component && access(e, role_by_id)) {
                        return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={e.component({
												level: {
													parent: props?.level,
													uuid: e?.uuid,
													name: e?.name,
													color: e?.color,
													role: e?.role,
                                                    hidden: e.hidden
												},
											 status, notify })} />
                    }
                })}
            </Routes>
        </div>
    )
}

